<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :title="modalData.title"
        width="350px"
        append-to-body
        :before-close="handleClose">
        <div>
            <el-form ref="form" :model="formItem" label-width="0">
                <el-form-item label="" class="label-required" style="margin-bottom: 0;">
                    <ESelect v-model="formItem.select" placeholder="请选择" class="full-w">
                        <el-option
                            v-for="item in optionList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </ESelect>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" class="action-btn ml20">确认</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import API from '@/api/mediaAccount.js';
    import utils from '@/libs/utils.js'

    export default {
        name: "SelectModal",
        components: {},
        props: {
            modalData:{
                type:Object,
                required:true,
            },
            platId:{
                type: [String,Number],
                required: true,
            },
        },
        data() {
            return {
                dialogVisible: false,
                submitLoading: false,
                formItem: {
                    select:'',
                },
                // rules: {
                //     data_range: [
                //         {type: 'array', required: true, message: '请选择日期', trigger: 'change'}
                //     ]
                // },
                optionList:[],

            }
        },
        computed: {

        },
        methods: {
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
                this.$emit('close',this.modalData);
            },
            resetForm() {
                this.formItem.range_time = [];
                this.submitLoading = false;
                this.$refs['form'].resetFields();
            },
            showModal() {
                this.dialogVisible = true;
                if(this.modalData.name=='cost_type'){
                    this.optionList = [
                        {
                            value:'1',
                            label:'总消耗',
                        },
                        {
                            value:'2',
                            label:'现金消耗',
                        },
                        {
                            value:'3',
                            label:'虚拟金消耗',
                        },
                    ];
                }
                this.formItem.select = this.modalData.selectValue;
            },
            handleSubmit() {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        let selectItem = this.optionList.find(item=>item.value==this.formItem.select)||{};
                        this.$emit('save-value',this.modalData,{
                            select:this.formItem.select,
                            selectLabel:selectItem.label,
                        },'select');
                        this.handleClose();
                    } else {
                        return false;
                    }
                });
            },

        }
    }
</script>

<style lang="scss" scoped>
    .action-btn {
        /*width: 120px;*/
    }

    ::v-deep .el-dialog__body{
        padding: 20px;
    }

</style>
